module.exports = __webpack_public_path__ + "card2-v1.90f7dfd5cebfe24b0110526a01b05d5a.jpg";